const rules = {
  required: "Field is required DE",
  email: "The email is invalid DE",
  postalCode: "Field must be 5 characters in length DE",
  integer: "Only integer are valid DE",
};
export default rules;
